<template>
  <el-row class="order">
    <el-col :span="24">
      <el-input
        v-model="keyword"
        placeholder="订单号、商品名、收件人、手机号"
        prefix-icon="el-icon-search"
        @input="refresh"
        clearable
        size="small"
        style="width:260px">
      </el-input>
      <el-button icon="el-icon-refresh" @click="refresh" size="small" type="primary">刷新</el-button>
      <el-button icon="el-icon-download" size="small" type="primary" @click="showDialog">导出</el-button>
    </el-col>
    <el-col :span="24" style="margin-top:10px">
      <el-tabs value="freight_pending" @tab-click="clickHandle">
        <el-tab-pane :label="'待发货（'+dataList['freight_pending'].total+'）'" name="freight_pending">
          <order-item
            :data="dataList['freight_pending']"
            key="freight_pending"
            @action-success="refresh"
            @currentChange="currentChange($event,'freight_pending')">
          </order-item>
        </el-tab-pane>
        <el-tab-pane :label="'待付款（'+dataList['pay_pending'].total+'）'" name="pay_pending">
          <order-item
            :data="dataList['pay_pending']"
            key="pay_pending"
            @action-success="refresh"
            @currentChange="currentChange($event,'pay_pending')">
          </order-item>
        </el-tab-pane>
        <el-tab-pane :label="'已发货（'+dataList['freighted'].total+'）'" name="freighted">
          <order-item
            :data="dataList['freighted']"
            key="freighted"
            @action-success="refresh"
            @currentChange="currentChange($event,'freighted')">
          </order-item>
        </el-tab-pane>
        <el-tab-pane :label="'售后中（'+dataList['aftersale_pending'].total+'）'" name="aftersale_pending">
          <order-item
            :data="dataList['aftersale_pending']"
            key="aftersale_pending"
            @action-success="refresh"
            @currentChange="currentChange($event,'aftersale_pending')">
          </order-item>
        </el-tab-pane>
        <el-tab-pane :label="'全部（'+dataList['all'].total+'）'" name="all">
          <order-item
            :data="dataList['all']"
            key="all"
            @action-success="refresh"
            @currentChange="currentChange($event,'all')">
          </order-item>
        </el-tab-pane>
      </el-tabs>
    </el-col>
    <el-dialog
      title="提示"
      :visible.sync="visible"
      width="600px">
      <el-form label-width="100px">
        <el-form-item label="关键词">
          <el-input
            v-model="excelKey"
            style="width:350px;"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="选择时间段">
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable>
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="uploadExcel">确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>
<script>
import '@/components/AddressSelect/index'
import '@/components/EditLayer/index'
import OrderItem from './components/orderItem'
import request from '@/utils/request'
export default {
  name: 'OrderList',
  components: {
    OrderItem
  },
  data () {
    return {
      visible: false,
      time: [],
      excelKey: '',
      keyword: '',
      dataList: {
        freight_pending: {},
        pay_pending: {},
        freighted: {},
        aftersale_pending: {},
        all: {}
      },
      activeTab: 'freight_pending',
      per_page: 4,
      statusKeys: ['freight_pending', 'pay_pending', 'freighted', 'aftersale_pending', 'all']
    }
  },
  created () {
    this.init()
  },
  methods: {
    showDialog () {
      this.visible = true
      this.excelKey = ''
      this.time = []
    },
    uploadExcel () {
      window.open(`${process.env.BASE_API}/movie-order-exp?start_at=${this.time[0]}&end_at=${this.time[1]}&key=${this.excelKey}`, '_blank')
    },
    init () {
      let statusKeys = this.statusKeys
      for (let i = 0; i < statusKeys.length; i++) {
        this.dataList[statusKeys[i]] = {
          page: 1,
          list: [],
          per_page: this.per_page,
          total: 0,
          status: statusKeys[i]
        }
      }
      // 商品列表
      this.getOrderList('freight_pending') // 待发货
      this.getOrderList('pay_pending') // 待付款
      this.getOrderList('freighted') // 已发货
      this.getOrderList('aftersale_pending') // 售后中
      this.getOrderList('all').then(res => {
        // this.$store.dispatch('getUnread').then(() => {})
      }) // 全部
    },
    clickHandle (tab) {
      this.activeTab = tab.name
    },
    getOrderList (status) {
      return new Promise((resolve, reject) => {
        let sendData = {
          status: status,
          key: this.keyword,
          per_page: this.per_page,
          page: this.dataList[status].page
        }
        request({
          url: 'movie-orders',
          method: 'get',
          params: sendData
        }).then(res => {
          resolve()
          this.dataList[status].list = res.data.list
          this.dataList[status].total = res.data.item_total
        }).catch(err => {
          reject(err)
        })
      })
    },
    currentChange (e, status) {
      this.dataList[status].page = e
      this.getOrderList(status)
    },
    refresh (status) {
      this.getOrderList('freight_pending') // 待发货
      this.getOrderList('pay_pending') // 待付款
      this.getOrderList('freighted') // 已发货
      this.getOrderList('aftersale_pending') // 售后中
      this.getOrderList('all').then(res => {
        // this.$store.dispatch('getUnread').then(() => {})
      }) // 全部
    }
  }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/movieOrder.vue